export default {
    methods: {
        versionRiskLevel: function(item, version) {
            if (version == "teaser") {
                version = "lite"
            }
            return item[`risk_level_${version}`];
        }
    }
};
